import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-buscar-cliente",
  templateUrl: "./buscar-cliente.component.html",
  styleUrls: ["./buscar-cliente.component.css"],
})
export class BuscarClienteComponent {
  tiposDocumento: any[];
  filtros = {
    tipoDocumento: "",
    noDocumento: "",
  };

  constructor(
    public dialogRef: MatDialogRef<BuscarClienteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.tiposDocumento = data.tiposDocumento;
  }

  limpiar() {
    this.filtros = {
      tipoDocumento: "",
      noDocumento: "",
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-clientes/shared/components/buscar-cliente/buscar-cliente.component.ts